module.exports = __webpack_public_path__ + "static/media/2.ed3c00e9.jpg";